export enum InvitationStatus
{
    Valid,
    NotInvited,
    InvalidDomain
}